import React, {useContext} from 'react';
import {FirebaseContext} from '../Firebase';
import IconButton from '@material-ui/core/IconButton';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import girl1 from '../../images/avatar/girl1.svg';
import girl2 from '../../images/avatar/girl2.svg';
import girl3 from '../../images/avatar/girl3.svg';
import girl4 from '../../images/avatar/girl4.svg';
import girl5 from '../../images/avatar/girl5.svg';
import girl6 from '../../images/avatar/girl6.svg';
import girl7 from '../../images/avatar/girl7.svg';
import girl8 from '../../images/avatar/girl8.svg';
import girl9 from '../../images/avatar/girl9.svg';
import girl10 from '../../images/avatar/girl10.svg';
import boy1 from '../../images/avatar/boy1.svg';
import boy2 from '../../images/avatar/boy2.svg';
import boy3 from '../../images/avatar/boy3.svg';
import boy4 from '../../images/avatar/boy4.svg';
import boy5 from '../../images/avatar/boy5.svg';
import boy6 from '../../images/avatar/boy6.svg';
import boy7 from '../../images/avatar/boy7.svg';
import boy8 from '../../images/avatar/boy8.svg';
import boy9 from '../../images/avatar/boy9.svg';
import boy10 from '../../images/avatar/boy10.svg';

const Logout = (props) => {
  const firebase = useContext(FirebaseContext);
  const {pseudo} = props.userData;
  const {group} = props.userData;
  const {codeAvatar} = props.userData;
  console.log(codeAvatar !== undefined);
  function SwitchCase(value) {
    switch (value[0]) {
      case '1':
        return boy1;
      case '2':
        return boy2;
      case '3':
        return boy3;
      case '4':
        return boy4;
      case '5':
        return boy5;
      case '6':
        return boy6;
      case '7':
        return boy7;
      case '8':
        return boy8;
      case '9':
        return boy9;
      case '10':
        return boy10;
      case '11':
        return girl1;
      case '12':
        return girl2;
      case '13':
        return girl3;
      case '14':
        return girl4;
      case '15':
        return girl5;
      case '16':
        return girl6;
      case '17':
        return girl7;
      case '18':
        return girl8;
      case '19':
        return girl9;
      case '20':
        return girl10;
      default:
        return 'erreur';
    }
  }
  // src={SwitchCase(parseInt(codeAvatar[0]))}
  return (
    <div className="logoutContainer">
      <p>
       {pseudo}
      </p> 
      {codeAvatar !== undefined &&(<img className={'avatarImg'} src={SwitchCase(codeAvatar)} alt="avatar" />)}
      <IconButton
        style={{
          marginRight: '50px',
        }}
        className={'tooltip'}
        aria-label="delete"
        onClick={() => firebase.signoutUser()}
      >
        <ExitToAppIcon />
        <span className={'tooltiptext'}>Se déconnecter</span>
      </IconButton>
    </div>
  );
};

export default Logout;
